// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AppProvider } from "./context/AppVarsContext";
import Survey from "./views/survey/Survey";
import SurveyResults from "./views/survey/Results";
import themeFile from './theme.json';
import { createTheme, ThemeProvider } from "@mui/material";
import NotFound from "./views/not-found";
import Homepage from "./views/hompepage";

const App = () => {

  const theme = createTheme(themeFile);


  return (
    <Router>
      <ThemeProvider theme={theme}>
        <AppProvider appid={"146e5e5a-2fdf-4868-a4ab-3e441afb64ad"}>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/nps/:id" element={<Survey/>} />
            <Route path="/RS/:id" element={<SurveyResults/>} />
            {/* 404 Not Found Route */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AppProvider>
      </ThemeProvider>
    </Router>

  );
};

export default App;
